import styles from '../styles/modules/Skelet.module.scss';

const Skelet = ({ children, height, maxHeight, width, maxWidth, style, className, invert }) => {
  return (
    <div
      className={[styles.skelet, className, invert && styles.invert].filter(Boolean).join(' ')}
      style={{ height, maxHeight, width, maxWidth, ...style }}
    >
      {children}
    </div>
  );
};

export default Skelet;
